function StatusBadge({ status }) {
  const STATUS_STYLES = {
    Available: "bg-emerald-50 text-emerald-700",
    Assigned: "bg-indigo-50 text-indigo-700",
    "In Repair": "bg-amber-50 text-amber-700",
    Lost: "bg-red-50 text-red-700",
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-sm font-semibold ${
        STATUS_STYLES[status] ?? "bg-gray-100 text-gray-600"
      }`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}

export default StatusBadge;
